module.exports = __webpack_public_path__ + "static/img/djkx5.a5b48df.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx5.jpeg
// module id = aa6h
// module chunks = 1